(function () {
  var GET_IN_TOUCH_HULK_FORM_ID = 'o7QQzmmXYJImNWTKtn0fWg';
  // The form's only field, labelled exactly as in Hulk Form Builder.
  var GET_IN_TOUCH_HULK_FIELD_LABEL = 'Price Request Received';
  // Blank Slate's shop id in Hulk Form Builder (window.hulkFormBuilder.shop_data).
  var GET_IN_TOUCH_HULK_SHOP_UUID = 'bFrv5k7thZAeyzHqQ6MYRA';
  var GET_IN_TOUCH_HULK_ENDPOINT = 'https://formbuilder.hulkapps.com/ajaxcall/formresponse';
  var GET_IN_TOUCH_GEO_ENDPOINT = 'https://ipwho.is/';
  // IP-only fallback for when the geo lookup fails (e.g. ipwho.is rate limit).
  var GET_IN_TOUCH_IP_ENDPOINT = 'https://api.ipify.org?format=json';
  var GET_IN_TOUCH_LOOKUP_TIMEOUT_MS = 4000;
  // Theme buttons with "Submit Hulk notification form on click" enabled, plus the
  // floating chat button injected by the WhatsApp app embed (dondy-whatsapp).
  var BUTTON_SELECTOR = '.hulk-notify-button, #whatsapp-widget-root a';

  // Capture phase, so it still runs if the app's widget stops the click from bubbling.
  document.addEventListener('click', function (event) {
    if (!event.target.closest(BUTTON_SELECTOR)) return;

    getInTouchFetchGeo().then(function (geo) {
      var ipPromise = geo && geo.ip ? Promise.resolve(geo.ip) : getInTouchFetchIp();

      return ipPromise.then(function (ip) {
        var ipText = ip || 'unknown';
        var locationParts = geo
          ? [geo.city, geo.region, geo.country].filter(Boolean)
          : [];
        var locationText = locationParts.length
          ? locationParts.join(', ')
          : 'location unavailable';

        submitHulkForm(ipText + ' (' + locationText + ')');
      });
    });
  }, true);

  var getInTouchGeoPromise = null;
  var getInTouchIpPromise = null;

  function getInTouchFetchGeo() {
    if (getInTouchGeoPromise) return getInTouchGeoPromise;

    getInTouchGeoPromise = getInTouchFetchJson(GET_IN_TOUCH_GEO_ENDPOINT, 'Geo').then(
      function (data) {
        if (data && data.success === false) {
          console.warn('[get-in-touch] Geo lookup unsuccessful.', data);
          return null;
        }
        return data;
      }
    );

    return getInTouchGeoPromise;
  }

  function getInTouchFetchIp() {
    if (getInTouchIpPromise) return getInTouchIpPromise;

    getInTouchIpPromise = getInTouchFetchJson(GET_IN_TOUCH_IP_ENDPOINT, 'IP').then(
      function (data) {
        return (data && data.ip) || null;
      }
    );

    return getInTouchIpPromise;
  }

  // Resolves with the parsed JSON, or null on error or timeout.
  function getInTouchFetchJson(url, label) {
    return new Promise(function (resolve) {
      var settled = false;
      var timeoutId = setTimeout(function () {
        if (settled) return;
        settled = true;
        console.warn('[get-in-touch] ' + label + ' lookup timed out.');
        resolve(null);
      }, GET_IN_TOUCH_LOOKUP_TIMEOUT_MS);

      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (settled) return;
          settled = true;
          clearTimeout(timeoutId);
          console.log('[get-in-touch] ' + label + ' lookup resolved:', data);
          resolve(data);
        })
        .catch(function (error) {
          if (settled) return;
          settled = true;
          clearTimeout(timeoutId);
          console.warn('[get-in-touch] ' + label + ' lookup failed.', error);
          resolve(null);
        });
    });
  }

  function getInTouchPrefetchGeo(event) {
    if (!event.target.closest(BUTTON_SELECTOR)) return;
    getInTouchFetchGeo();
  }

  document.addEventListener('pointerover', getInTouchPrefetchGeo);
  document.addEventListener('touchstart', getInTouchPrefetchGeo, {
    passive: true,
  });

  // Sends the same request Hulk's own app embed sends when it renders a form
  // on the page (hulkFBPostFormResponse in its extra-functions.js). Posting it
  // directly avoids the hidden form, which Hulk now loads in a cross-origin
  // iframe that the page can't fill in.
  function submitHulkForm(message) {
    var formResponse = {};
    formResponse[GET_IN_TOUCH_HULK_FIELD_LABEL] = message;

    console.log('[get-in-touch] Submitting Hulk form with message:', message);

    fetch(GET_IN_TOUCH_HULK_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shop-UUID': GET_IN_TOUCH_HULK_SHOP_UUID,
      },
      body: JSON.stringify({
        form_uuid: GET_IN_TOUCH_HULK_FORM_ID,
        formResponse: JSON.stringify(formResponse),
        confirmationMail: true,
        email_check: '',
        utm_params: null,
        referrer_url: null,
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        console.log('[get-in-touch] Hulk form submitted:', data);
      })
      .catch(function (error) {
        console.warn('[get-in-touch] Hulk form submission failed.', error);
      });
  }
})();
